import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-employer-record-contact-remove-modal',
  templateUrl: './employer-record-contact-remove-modal.component.html',
  styleUrls: ['./employer-record-contact-remove-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerRecordContactRemoveModalComponent {
  private activeModal = inject(NgbActiveModal);

  public contactName: string = '';

  public setEmployerContactName(contactName: string): void {
    this.contactName = contactName;
  }

  public close(): void {
    this.activeModal.close();
  }

  public confirm(): void {
    this.activeModal.close(true);
  }
}
